<template>
  <div>
    <div>
      <div class="ProductAnalysisHomeTabs mt-2">
        <swiper
            :slidesPerView="2.5"
            :breakpoints="{ '1024': { slidesPerView: 6.8 } }"
            dir="rtl"
        >
          <swiper-slide
              class="ProductAnalysisHomeTab d-flex justify-content-center pointer text-nowrap"
              v-for="analysisType in analysisTypes"
              :key="analysisType.id"
              @click="getSingleAnalysis(analysisType)"
              :class="{ activeTab: activeAnalysisId === analysisType.id }"
              :disabled="analysisType.mode !== 'رایگان'"
          >
            <div>{{ analysisType.name }}</div>
            <div v-if="analysisType?.description">
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="me-2"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  @click.stop="openDescriptionModal(analysisType)"
              >
                <g fill="none">
                  <circle cx="12" cy="12" r="9.25" stroke="#aaabac" stroke-width="1.5" />
                  <path stroke="#aaabac" stroke-linecap="round" stroke-width="1.5" d="M12 11.813v5" />
                  <circle cx="12" cy="8.438" r="1.25" fill="#aaabac" />
                </g>
              </svg>
            </div>
          </swiper-slide>
        </swiper>
      </div>
      <div
          class="d-flex justify-content-center margin-at-mobile"
          v-if="activeAnalysisData !== null && !hasMapData && !hasChartData && !hasSummaryData">
        <p style="margin-top: 50px">آنالیز وجود ندارد</p>
      </div>
      <div
          class="d-flex justify-content-center margin-at-mobile"
          v-if="!singleService"
      >
        <p style="margin-top: 50px">گیاهی برای مزرعه شما ثبت نشده</p>
      </div>
      <div class="map-wrapper">
        <div
            ref="map-root"
            class="map p-3 p-md-0 position-relative"
            :class="{
              activeMap:
                activeAnalysisData !== null && !hasMapData,
            }"
            @click="getAnalysisValue"
        >

<!--          <div v-if="activeAnalysisData === null" class="d-flex flex-column align-items-center justify-content-center">-->
<!--            <p dir="rtl">در حال دریافت اطلاعات ...</p>-->
<!--            <Loading/>-->
<!--          </div>-->
          <!-- Dates carousel -->
          <div v-if="selectedDate !== null" class="overflow-hidden dates-carousel d-flex justify-content-between"
               dir="rtl">
            <!-- scroll to end button -->
            <button @click="scrollToEnd" class="custom-nav custom-prev">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path
                      d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/>
                  <path fill="#aaabac"
                        d="M16.06 10.94a1.5 1.5 0 0 1 0 2.12l-5.656 5.658a1.5 1.5 0 1 1-2.121-2.122L12.879 12L8.283 7.404a1.5 1.5 0 0 1 2.12-2.122l5.658 5.657Z"/>
                </g>
              </svg>
            </button>

            <!-- Scrollable container -->
            <div
                ref="scrollContainer"
                class="d-flex overflow-x-auto scrollbar-hide scroll-smooth flex-1"
            >
              <div
                  v-for="(item, index) in filterDates"
                  :key="index"
                  @click="changeDate(item.date)"
                  class="shrink-0 text-center date-box"
                  :class="{ 'active-date': selectedDate === item.date }"
              >
                <p class="mb-0">{{ item.date }}</p>
                <div class="d-flex align-items-center justify-content-center gap-1 date-info">
                  <p class="mb-0 text-nowrap">%{{ item.cloud_percentage }} -</p>
                  <p class="mb-0 text-nowrap">{{ item.sensor }}</p>
                </div>
              </div>
            </div>

            <!-- scroll to start button -->
            <button @click="scrollToStart" class="custom-nav custom-next">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path
                      d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"/>
                  <path fill="#aaabac"
                        d="M7.94 13.06a1.5 1.5 0 0 1 0-2.12l5.656-5.658a1.5 1.5 0 1 1 2.121 2.122L11.122 12l4.596 4.596a1.5 1.5 0 1 1-2.12 2.122l-5.66-5.658Z"/>
                </g>
              </svg>
            </button>
          </div>
          <!--                        show point value-->
          <!--                        <div ref="popup-point">-->
          <!--                            <p v-if="pointValue !== ''" class="point-value">-->
          <!--                                {{ pointValue }}-->
          <!--                            </p>-->
          <!--                        </div>-->
        </div>
        <div
            class="row margin-16-at-mobile"
            v-if="activeAnalysisData !== null && hasMapData"
        >

          <!-- north icon -->
          <div class="north_icon">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 56 56"><path fill="#ffffff" d="M11.992 52.375c1.172 0 1.922-.422 3.07-1.547l12.61-12.492c.117-.117.21-.211.328-.211c.117 0 .211.094.328.21l12.61 12.493c1.148 1.125 1.898 1.547 3.07 1.547c1.57 0 2.554-1.219 2.554-2.812c0-.891-.374-1.946-.726-2.907L31.188 6.625c-.75-2.062-1.852-3-3.188-3s-2.437.938-3.187 3L10.164 46.656c-.351.961-.726 2.016-.726 2.907c0 1.593.984 2.812 2.554 2.812"/></svg>
            </div>
          </div>

          <!-- Legend show -->
          <div class="legend-position col-1">
            <p class="mx-2 mb-0" style="color: white">1</p>
            <div class="position-absolute">

              <!-- colors bar -->
              <div
                  v-for="(color, index) in map_legend"
                  :key="index"
                  class="position-relative"
                  style="height: 23px"
              >
                <div class="legend-color"
                     @click="handleShowDetails()"
                     :style="{ backgroundColor: color, width: '25px', height: '23px' }">
                </div>
              </div>

              <!-- color details -->
              <div
                  v-if="detailsVisible"
                  class="detailsBox"
              >
                <div v-for="(content, i) in detailsContent"
                     :key="i"
                     v-html="content"
                     style="height: 23px">
                </div>
              </div>
              <div @click="handleShowDetails" class="info-btn mt-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 12 12"><path fill="#ffffff" d="M11 6A5 5 0 1 1 1 6a5 5 0 0 1 10 0m-5.5.5V8a.5.5 0 0 0 1 0V6.5a.5.5 0 0 0-1 0M6 3.75a.75.75 0 1 0 0 1.5a.75.75 0 0 0 0-1.5"/></svg>
              </div>
<!--              <div class="mx-2" style="color: white">0</div>-->
            </div>

            <!--            &lt;!&ndash; Legend value Tooltip &ndash;&gt;-->
            <!--            <div-->
            <!--                v-if="tooltipVisible"-->
            <!--                class="legend-tooltip"-->
            <!--                :style="{ top: tooltipY + 'px', left: tooltipX + 'px' }"-->
            <!--            >-->
            <!--              {{ tooltipContent }}-->
            <!--            </div>-->
          </div>

          <div class="manage-layers" v-if="farm.type === 'garden'">
            <div class="d-flex map-tools">
              <div
                  class="d-flex flex-column align-items-center justify-content-end date-wrapper"
              >
                <div v-for="(mapLayer, index) in mapLayers" :key="mapLayer.id">
                  <div class="form-check">
                    <input
                        type="checkbox"
                        :id="mapLayer.id"
                        :value="mapLayer.name"
                        :checked="mapLayer.checked"
                        class="form-check-input"
                        @click="selectLayer(mapLayer, index)"
                    />
                    <label class="form-check-label mx-2" :for="mapLayer.id">{{
                        mapLayer.name
                      }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--          <div class="tools-wrapper">-->
          <!--            <div class="d-flex map-tools">-->
          <!--              <div-->
          <!--                  v-if="selectedDate !== null"-->
          <!--                  class="d-flex flex-column align-items-center justify-content-end date-wrapper"-->
          <!--              >-->
          <!--                <div-->
          <!--                    class="d-flex justify-content-center align-items-center select-date-label"-->
          <!--                >-->
          <!--                  تاریخ آنالیز را انتخاب کنید-->
          <!--                </div>-->
          <!--                <div class="input-icons">-->
          <!--                  <input-->
          <!--                      type="text"-->
          <!--                      class="input-field"-->
          <!--                      v-model="selectedDate"-->
          <!--                      id="selected-date-input"-->
          <!--                  />-->
          <!--                </div>-->
          <!--                <date-picker-->
          <!--                    v-model="selectedDate"-->
          <!--                    @change="getDate"-->
          <!--                    :disable="checkDate"-->
          <!--                    element="selected-date-input"-->
          <!--                    color="#7a7a79"-->
          <!--                    :auto-submit="true"-->
          <!--                    :initial-value="selectedDate"-->
          <!--                />-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
      </div>
      <div
          class="row margin-16-at-mobile analysis-report-section"
          v-if="activeAnalysisData !== null && (hasChartData || hasSummaryData || hasMapData)"
      >
          <div class="col-12 col-md-12 dateReport mt-5">
            <div
                class="d-flex flex-column h-100 justify-content-between"
                v-if="hasSummaryData"
            >
              <div
                  class="d-flex justify-content-between align-items-center flex-row-reverse dateReport-tab text-nowrap"
              >
                <div
                    v-for="(summaryItem, index) in activeAnalysisData.summary"
                    class="dateReport-tab-title"
                    :class="{
                    'dateReport-tab-title-active':
                      summeryActiveTab === summaryItem.title,
                  }"
                    @click="getSummery(summaryItem)"
                    :key="index"
                >
                  {{ summaryItem.title }}
                </div>
              </div>
              <div v-if="summary != null" class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col-12 text-center timeTabValue">
                      {{ summary.average && summary.average.value != null ? summary.average.value : "-" }}
                    </div>
                    <div class="col-12 timeTabValueText">
                      {{ summary.description }}
                    </div>
                  </div>
                </div>
                <div class="col-6 border-left">
                  <div class="row">
                    <div class="col-2 d-inline-block">
                      <font-awesome-icon
                          icon="arrow-up"
                          size="2x"
                          color="#29bb89"
                      ></font-awesome-icon>
                    </div>
                    <div class="col-2 d-inline-block timeTabValueMax">
                      {{ summary.max && summary.max.value != null ? summary.max.value : "-" }}
                    </div>
                    <div class="col-8 d-inline-block text-center timeTabText">
                      بیشترین مقدار
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-2 d-inline-block">
                      <font-awesome-icon
                          icon="arrow-down"
                          size="2x"
                          color="#ec4b4b"
                      ></font-awesome-icon>
                    </div>
                    <div class="col-2 d-inline-block timeTabValueMin">
                      {{ summary.min && summary.min.value != null ? summary.min.value : "-" }}
                    </div>
                    <div class="col-8 d-inline-block text-center timeTabText">
                      کمترین مقدار
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <p class="text-center pt-2">هیچ گزارشی ثبت نشده است</p>
            </div>
          </div>
          <div class="col-12 col-md-12 d-flex align-items-end w-100">
            <JalizbanChart
                v-if="hasChartData"
                :key="'jalizban-chart-' + activeAnalysisId"
                class="w-100"
                :chartData="chartData"
                :chartDataLegned="chartDataLegned"
                :chartTitle="chartTitle"
            />
            <p class="text-center pt-2 w-100" v-else>نموداری گزارش نشده است</p>
          </div>
        </div>
    </div>

    <!-- Analysis Description Modal -->
    <transition name="popup">
      <template v-if="showDescriptionModal">
        <div class="description-modal-overlay" @click.self="closeDescriptionModal">
          <div class="modal-content">
            <div class="modal-body">
             <div class="d-flex justify-content-between align-items-center mb-3">
               <h6 class="mb-0"> {{ selectedAnalysis.name }}</h6>
               <button class="modal-close" @click="closeDescriptionModal">×</button>
             </div>
              <p>{{ selectedAnalysis.description }}</p>
            </div>
          </div>
        </div>
      </template>
    </transition>

  </div>
</template>

<script>
import JalizbanChart from "./JalizbanChart.vue";
import {mapMixin} from "../../mixins/mapMixin";
import {globalMixin} from "../../mixins/globalMixin";
import moment from "moment-jalaali";
import Api from "../../common/api";
import { nextTick } from 'vue';

export default {
  name: "AnalyzeHome",
  components: {JalizbanChart},
  mixins: [mapMixin, globalMixin],
  inject: ["$axios"],
  props: {
    farm: {
      type: Object,
    },
    plant: {
      type: Object,
    },
    analysisTypes: {
      type: Array,
    },
    singleService: {
      type: Object,
    },
  },
  data() {
    return {
      tooltipVisible: false,
      tooltipContent: "",
      tooltipX: 0,
      tooltipY: 0,
      colorMaps: {
        ndvi: [
          "#550305",
          "#6d0204",
          "#840003",
          "#a80004",
          "#cc0004",
          "#e21103",
          "#ef3103",
          "#fc5003",
          "#fe6704",
          "#ff7e04",
          "#e8b805",
          "#b6d304",
          "#90e203",
          "#69f101",
          "#4ef400",
          "#3be900",
          "#00b400",
          "#009900",
          "#007e00",
          "#09660e",
        ].reverse(),
        water_tension: [
          "#820002",
          "#9f0000",
          "#ca0202",
          "#ff2d03",
          "#fe7000",
          "#fbb000",
          "#fdcf00",
          "#efe712",
          "#c6f338",
          "#9dff5d",
          "#6fff8e",
          "#43fbbb",
          "#00effc",
          "#01c0fd",
          "#0291fe",
          "#0255fd",
          "#0100fc",
          "#0000de",
          "#0100be",
          "#000191",
        ].reverse(),
        leaf_area: [
          "#790909",
          "#B70404",
          "#CF0007",
          "#E41C08",
          "#EF6805",
          "#F48E04",
          "#D1AA03",
          "#ADC502",
          "#89E001",
          "#65FB00",
          "#3BF302",
          "#11EB03",
          "#1ADA04",
          "#23C904",
          "#18AE04",
          "#14A404",
          "#0F8903",
          "#0A6E02",
          "#055301",
          "#003700",
        ].reverse(),
        ndwi: [
          "#820002",
          "#9f0000",
          "#ca0202",
          "#ff2d03",
          "#fe7000",
          "#fbb000",
          "#fdcf00",
          "#efe712",
          "#c6f338",
          "#9dff5d",
          "#6fff8e",
          "#43fbbb",
          "#00effc",
          "#01c0fd",
          "#0291fe",
          "#0255fd",
          "#0100fc",
          "#0000de",
          "#0100be",
          "#000191",
        ].reverse(),
        gci: [
          "#5A0707",
          "#890606",
          "#A00505",
          "#B70404",
          "#C31304",
          "#E63F04",
          "#F35F04",
          "#F47D05",
          "#EE9B05",
          "#E8B805",
          "#DAC505",
          "#CBD105",
          "#ADEA05",
          "#8AE204",
          "#67DA03",
          "#43D102",
          "#33BD02",
          "#22A801",
          "#007E00",
          "#09660E",
        ].reverse(),
        ndre: [
          "#FFFFE7",
          "#FFFFCE",
          "#FFFF9D",
          "#FDFF6B",
          "#FBFF39",
          "#F3D61D",
          "#EBAD00",
          "#CE8305",
          "#B1590A",
          "#8D3809",
          "#843009",
          "#802c09",
          "#7b2708",
          "#721f08",
          "#681607",
          "#5b1106",
          "#4e0b04",
          "#420702",
          "#3d0501",
          "#380300",
        ].reverse(),
        // gndvi: ["#580202", "#B70404"],
      },
      activeAnalysisName: "ndvi",
      activeAnalysisMin: 1,
      activeAnalysisMax: 0,
      activeAnalysisId: 1,
      activeAnalysisData: null,
      summeryActiveTab: "",
      summary: null,
      selectedSummary: null,
      chartData: [],
      chartDataLegned: [],
      chartTitle: "",
      mapOptions: {
        point: null,
        zoom: null,
        hasSearchBar: false,
      },
      chartDailyDates: [],
      selectedDate: null,
      selectedDaily: null,
      dailyChart: [],
      filterDates: [],
      mapLayers: [
        {
          id: 1,
          name: "نمایش آنالیز",
          checked: true,
          value: "analysisLayer",
        },
        {
          id: 2,
          name: "نمایش قطعه",
          checked: false,
          value: "sectionLayer",
        },
        {
          id: 3,
          name: "نمایش ردیف",
          checked: false,
          value: "lineLayer",
        },
        {
          id: 4,
          name: "نمایش درخت",
          checked: false,
          value: "treeLayer",
        },
      ],
      gardenBlock: null,
      gardenLines: [],
      gardenTrees: [],
      gardenTreesLength: 0,
      markerCoordinate: null,
      scrollContainer: null,
      map_legend: [],
      selectedDay: null,
      detailsVisible: false,
      detailsContent: '',
      colorRanges: [],
      showDescriptionModal: false,
      selectedAnalysis: null,
    };
  },
  watch: {
    analysisTypes: {
      handler(newTypes) {
        if (!newTypes || newTypes.length === 0) {
          this.activeAnalysisData = null;
          this.chartData = [];
          this.summary = null;
          return;
        }
        this.getSingleAnalysis(newTypes[0]);
      },
    },
    selectedDay: {
      handler(newVal) {
        if (newVal) {
          this.prepareColorRanges();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    showTooltip(event, content) {
      this.tooltipX = event.clientX + 10;
      this.tooltipY = event.clientY + 10;
      this.tooltipContent = content;
      this.tooltipVisible = true;
    },
    hideTooltip() {
      this.tooltipVisible = false;
    },
    clearMapFeatures() {
      if (this.map !== null) {
        let mapLayers = this.map.getLayers().array_;
        this.map
            .getLayers()
            .getArray()
            .slice()
            .forEach((item) => {
              if (mapLayers.indexOf(item) !== 0) {
                this.map.removeLayer(item);
              }
            });
      }
    },
    drawMapFeatures() {
      this.showJalizbanFeatures(
          this.farm.shape.coordinates,
          this.farm.center.coordinates,
          false,
          `farm${this.farm.service_id}`,
          "rgba(60, 179, 113, 0.8)",
          null
      );
      this.showJalizbanFeatures(
          this.plant.shape.coordinates,
          this.plant.center.coordinates,
          true,
          `plant${this.plant.id}`,
          "rgba(0, 106, 57, 0.5)",
          null
      );
    },
    getSingleAnalysis(analysis) {
      this.pointValue = "";
      if (analysis === undefined || analysis === null) return;

      this.activeAnalysisId = analysis.id;
      this.activeAnalysisName = analysis.alias;
      this.activeAnalysisData = analysis;
      this.summary = null;
      this.summeryActiveTab = "";

      if (Array.isArray(analysis.summary) && analysis.summary.length > 0) {
        this.getSummery(analysis.summary[0]);
      } else {
        this.summary = null;
      }

      this.chartTitle = analysis.name || "";
      this.getChartData(analysis);
      this.getFilterDates(analysis);
      this.map_legend = Array.isArray(analysis.map_legend)
          ? [...analysis.map_legend].reverse()
          : [];
      this.selectedDay = Array.isArray(analysis.map) && analysis.map.length > 0
          ? analysis.map[0]
          : null;

      this.$nextTick(() => {
        try {
          if (this.map === null) this.loadMap(this.mapOptions);
          this.clearMapFeatures();
          if (this.farm && this.farm.shape && this.plant && this.plant.shape) {
            this.drawMapFeatures();
          }
          if (Array.isArray(analysis.map) && analysis.map.length > 0) {
            this.getMapData(analysis.map[0]);
            this.selectedDate = moment(
                analysis.map[0].date.value,
                "YYYY-MM-DD"
            ).format("jYYYY/jMM/jDD");
          } else {
            this.selectedDate = null;
          }
        } catch (e) {
          console.error("Jalizban map render failed:", e);
        }
      });
    },
    getSummery(summery) {
      this.summeryActiveTab = summery && summery.title !== undefined ? summery.title : "";
      this.summary = summery;
    },
    getChartData(analysis) {
      if (!analysis) {
        this.chartData = [];
        this.chartDataLegned = [];
        return;
      }

      const rawDaily =
          analysis.daily_chart ||
          analysis.dailyChart ||
          analysis.chart_daily ||
          [];

      // always assign a new array so watchers/remount logic see a change
      this.chartData = Array.isArray(rawDaily) ? rawDaily.slice() : [];
      this.chartDataLegned = Array.isArray(analysis.chart)
          ? analysis.chart.slice()
          : [];
    },
    getMapData(mapObject) {
      if (!mapObject) return;
      let geoParams = mapObject.params;
      let mapImage = mapObject.map_image;
      this.mapLayers[0].checked = true;
      this.displayMapAnalysis(mapImage, this, geoParams);
      this.selectedDay = mapObject
    },
    getDate() {
      let date = moment(this.selectedDate, "jYYYY/jMM/jDD").format(
          "YYYY-MM-DD"
      );
      this.pointValue = "";
      if (Array.isArray(this.activeAnalysisData?.map) && this.activeAnalysisData.map.length > 0) {
        this.clearMapFeatures();
        this.drawMapFeatures();
        const selectedSrc = (item) => item.date.value === date;
        let arrayIndex = this.activeAnalysisData.map.findIndex(selectedSrc);

        // set min and max reverse
        //todo: should change map color on change of date
        if (Array.isArray(this.activeAnalysisData.daily_chart) && this.activeAnalysisData.daily_chart[arrayIndex]) {
          this.activeAnalysisMin =
              this.activeAnalysisData.daily_chart[arrayIndex]["max"];
          this.activeAnalysisMax =
              this.activeAnalysisData.daily_chart[arrayIndex]["min"];
        }

        this.getMapData(this.activeAnalysisData.map[arrayIndex]);
      }
    },
    async changeDate(date) {
      this.selectedDate = date;
      this.getDate();

      await nextTick();
      this.showDetails();
    },
    getFilterDates(analysis) {
      const mapData = Array.isArray(analysis.map) ? analysis.map : [];
      const dateMap = new Map(); // Using Map to store date info

      if (mapData.length > 0) {
        mapData.forEach((item) => {
          if (item.date?.value) {
            const formattedDate = moment(item.date.value, "YYYY-MM-DD").format("jYYYY/jMM/jDD");

            dateMap.set(formattedDate, {
              date: formattedDate,
              cloud_percentage: item.cloud_percentage,
              sensor: item.sensor
            });
          }
        });

        this.filterDates = Array.from(dateMap.values());
      }
    },
    checkDate(formatted) {
      if (this.filterDates.length > 0)
        return !this.filterDates.includes(formatted);
    },
    selectLayer(layer, index) {
      this.pointValue = "";
      let mapLayers = this.mapLayers;
      let selectedItem = layer;
      selectedItem.checked = !layer.checked;
      mapLayers[index] = selectedItem;
      this[selectedItem.value] = selectedItem.checked;
      this.mapLayers = mapLayers;
      this.markerCoordinate = null;
      this.manageLayer(layer);
    },
    manageLayer(layer) {
      let layerId = layer.id;
      switch (layerId) {
        case 1:
          this.manageAnalysis(layer);
          break;
        case 2:
          this.managePolygon(layer);
          break;
        case 3:
          this.manageLine(layer);
          break;
        case 4:
          this.managePoint(layer);
          break;
      }
    },
    manageAnalysis(layer) {
      if (!layer.checked) {
        this.deleteMapLayer(this, layer);
      } else {
        this.getDate();
      }
    },
    managePolygon(layer) {
      if (layer.checked) {
        this.getGardenBlock(layer);
        this.showAnalysisPolygon(
            this.singleService.shape.coordinates,
            this.singleService.center.coordinates,
            true
        );
      } else {
        this.deleteMapLayer(this, layer);
      }
    },
    manageLine(layer) {
      if (layer.checked) {
        this.getGardenBlock(layer);
      } else {
        this.gardenLines = [];
        this.deleteMapLayer(this, layer);
      }
    },
    managePoint(layer) {
      if (layer.checked) {
        this.getGardenBlock(layer);
      } else {
        this.gardenTrees = [];
        this.gardenTreesLength = 0;
        this.deleteMapLayer(this, layer);
      }
    },
    getGardenBlock(layer) {
      let self = this;
      Api.singleGardenBlock({self: this, id: this.singleService.id})
          .then((res) => {
            if (res.status === 200) {
              let data = res.data;
              self.gardenBlock = data;
              self.gardenLines = data.garden_lines;

              data.garden_lines.map((item) => {
                if (layer.id === 3) {
                  this.showCreatedLine(item.line.coordinates);
                }
                if (layer.id === 4) {
                  self.gardenTreesLength += item.trees_count;
                  self.gardenTrees = self.gardenTrees.concat(item.garden_trees);
                }
              });

              if (layer.id === 4) {
                self.showMapPoints(self, layer);
              }
            }
          })
          .catch((error) => this.handleError(self, error));
    },
    getAnalysisValue(event) {
      this.getLayerData(event, this);
    },
    scrollToEnd() {
      if (!this.$refs.scrollContainer) return;
      this.$refs.scrollContainer.scrollBy({
        left: 200,
        behavior: 'smooth'
      });
    },

    scrollToStart() {
      if (!this.$refs.scrollContainer) return;
      this.$refs.scrollContainer.scrollBy({
        left: -200,
        behavior: 'smooth'
      });
    },
    prepareColorRanges() {
      if (!this.selectedDay || !this.selectedDay.percentage) return;

      const percentageKeys = Object.keys(this.selectedDay.percentage);
      const totalColors = this.map_legend.length;
      const numKeys = percentageKeys.length;

      const groupSize = Math.floor(totalColors / numKeys);
      const remainder = totalColors % numKeys;

      this.colorRanges = [];

      let colorIndex = 0;

      // ✅ Reverse to match high values (like 0.5-1.0) with top colors
      const orderedKeys = [...percentageKeys].reverse();

      orderedKeys.forEach((key, i) => {
        const currentGroupSize = groupSize + (i < remainder ? 1 : 0);

        for (let j = 0; j < currentGroupSize; j++) {
          this.colorRanges[colorIndex] = {
            key,
            percentage: this.selectedDay.percentage[key],
            area: this.selectedDay.area?.[key] ?? 0
          };
          colorIndex++;
        }
      });
    },
    showDetails() {
      if (!this.colorRanges || !this.colorRanges.length) return;

      const seen = new Set();
      const groupSizes = [];
      const keyOrder = [];

      // Pre-calculate group sizes based on prepareColorRanges logic
      const percentageKeys = Object.keys(this.selectedDay.percentage).reverse();
      const totalColors = this.map_legend.length;
      const numKeys = percentageKeys.length;
      const groupSize = Math.floor(totalColors / numKeys);
      const remainder = totalColors % numKeys;

      percentageKeys.forEach((key, i) => {
        const size = groupSize + (i < remainder ? 1 : 0);
        groupSizes.push(size);
        keyOrder.push(key);
      });

      this.detailsContent = [];
      let groupIndex = 0;
      let withinGroupIndex = 0;
      let totalCount = 0;

      this.colorRanges.forEach((range) => {
        const identifier = `${range.key}-${range.percentage}-${range.area}`;

        // Check if we're starting a new group
        if (totalCount >= groupSizes[groupIndex]) {
          groupIndex++;
          withinGroupIndex = 0;
          totalCount = 0;
        }

        let content = '';

        if (!seen.has(identifier)) {
          seen.add(identifier);

          const borderTop = groupIndex > 0 && withinGroupIndex === 0
              ? 'border-top: 1px dashed #646467; padding-top: 5px;'
              : '';

          content = `
                    <div class="text-nowrap mb-0 d-flex align-items-center gap-4" style="${borderTop}">
                        <p class="mb-0" style="width: 53px;">${range.key}</p>
                        <p class="mb-0">
                            <span class="d-inline-block" style="width: 60px;">% ${range.percentage}</span>
                            <span dir="rtl">${range.area} هکتار</span>
                        </p>
                    </div>

      `;
        } else {
          content = `<p></p>`;
        }

        this.detailsContent.push(content);
        withinGroupIndex++;
        totalCount++;
      });
    },
    handleShowDetails () {
      this.showDetails();
      this.detailsVisible = !this.detailsVisible;
    },
    openDescriptionModal(analysis) {
      this.selectedAnalysis = analysis;
      this.showDescriptionModal = true;
    },
    closeDescriptionModal() {
      this.showDescriptionModal = false;
      this.selectedAnalysis = null;
    },

  },
  computed: {
    hasMapData() {
      return Array.isArray(this.activeAnalysisData?.map) &&
          this.activeAnalysisData.map.length > 0;
    },
    hasChartData() {
      return Array.isArray(this.chartData) && this.chartData.length > 0;
    },
    hasSummaryData() {
      return Array.isArray(this.activeAnalysisData?.summary) &&
          this.activeAnalysisData.summary.length > 0;
    },
    valueSteps() {
      const steps = this.currentColorMap.length;
      const min = 1; // Assuming your min value
      const max = 0; // Assuming your max value
      let stepValues = [];
      for (let i = 0; i < steps; i++) {
        const value = min + (max - min) * (i / (steps - 1));
        stepValues.push(value.toFixed(2)); // Adjust decimal places as needed
      }
      return stepValues;
    },
    currentColorMap() {
      if (
          !this.activeAnalysisName ||
          !this.colorMaps[this.activeAnalysisName]
      ) {
        return []; // Return an empty array if no product is selected or if it doesn't have a color map
      }

      return this.colorMaps[this.activeAnalysisName];
    },
  },
  mounted() {
    this.scrollContainer = this.$refs.scrollContainer;

    // if (this.analysisTypes && this.analysisTypes.length > 0) {
    //   this.activeAnalysisData = this.analysisTypes[0];
    //   this.getFilterDates(this.analysisTypes[0]);
    // }

    // this.activeAnalysisData && this.activeAnalysisData.summary.length > 0
    //     ? (this.summary = this.activeAnalysisData.summary[0])
    //     : (this.summary = null);

    // this.summeryActiveTab =
    //     this.activeAnalysisData && this.activeAnalysisData.summary.length > 0
    //         ? this.activeAnalysisData.summary[0].title
    //         : "";
    // this.getChartData(this.activeAnalysisData);
    if (this.farm.type === "farm" || this.farm.type === "garden") {
      if (this.singleService !== undefined && this.singleService !== null) {
        this.mapOptions.point = this.singleService.center.coordinates;
        this.mapOptions.zoom =
            this.singleService.area !== null &&
            this.singleService.area.unit === "هکتار"
                ? 15
                : 18;
        // if (this.map === null) this.loadMap(this.mapOptions);
        // if (this.activeAnalysisData.map.length > 0) {
        //   this.getMapData(this.activeAnalysisData.map[0]);
        //   this.selectedDate = moment(
        //       this.activeAnalysisData.map[0].date.value,
        //       "YYYY-MM-DD"
        //   ).format("jYYYY/jMM/jDD");
        // }
      }
    }

    if (this.analysisTypes && this.analysisTypes.length > 0) {
      this.getSingleAnalysis(this.analysisTypes[0]);
    }
  },
};
</script>

<style lang="scss">
@import "~ol/ol.css";
@import "~ol-geocoder/dist/ol-geocoder.min.css";
@import "src/styles/modules/Home/AnalyzeHome";
@import "src/styles/modules/LandAndPlantRegistration/AddFarm";
</style>
<style>
.ProductAnalysisHomeTabs::-webkit-scrollbar {
  height: 2px;
}

.ProductAnalysisHomeTabs::-webkit-scrollbar-track {
  border-radius: 5px;
  /*box-shadow: inset 0 0 1px grey;*/
}

.ProductAnalysisHomeTabs::-webkit-scrollbar-thumb {
  background: #00a57a;
  border-radius: 5px;
}

.vpd-input-group {
  background-color: #fff;
  width: 129px;
  height: 36px;
  border-radius: 8px;
  padding: 6px 12px;
}

.vpd-input-group label {
  background-color: unset !important;
}

.vpd-input-group input {
  border: unset;
  padding: 0;
  margin-left: 8px;
}

.vpd-icon-btn {
  padding: 0;
}

.activeMap {
  /* keep map target in layout for OpenLayers; hide visually when no tiles */
  visibility: hidden;
  height: 0 !important;
  min-height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden;
  pointer-events: none;
}

.manage-layer-item {
  color: #fff;
  font-size: 12px;
  margin-right: 5px;
}

.point-value {
  color: #fff;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  font-size: 16px;
}

.input-field {
  padding: 5px;
  text-align: center;
  border-radius: 10px;
  background-color: #fff;
  border-width: 1px;
  border-color: #fff;
}

.legend-position {
  position: absolute;
  top: 100px;
  right: 0;
  left: 0;

  @media (max-width: 767px) {
    left: 16px;
  }
}

.legend-tooltip {
  position: fixed;
  z-index: 1000; /* Ensure it's on top */
  background-color: white;
  opacity: 0.5;
  padding: 5px;
}

.tooltip-container {
  border: 1px solid red; /* Temporary, for visualization */
  background-color: rgba(255, 255, 255, 0.9); /* Also temporary */
  /*z-index: 1000; !* Adjust as needed *!*/
}

.legend-img {
  width: 15px;
  height: 150px;
}

.legend-color {
  cursor: pointer;
}

.detailsBox {
  position: absolute;
  z-index: 100;
  left: 20px;
  top: 0;
  bottom: 0;
  font-size: 14px;
  background: #21211f;
  color: #eeeef3;
  height: max-content;

  p {
    padding: 2px 14px;
    font-size: 13px;
  }
}

.info-btn {
  width: 25px;
  height: 25px;
  background: #1d1d1ee3;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: rgba(41, 41, 43, 0.89);
  }
}

.north_icon {
  position: absolute;
  top: 9px;
  left: 40px;
  width: 28px;
  height: 28px;
  background: rgb(255 255 255 / 33%);
  border-radius: 4px;
  padding: 3px;

  @media screen and (max-width: 768px){
    top: 23px;
    left: 55px;
  }

  div {
    background: rgba(0, 60, 136, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
}
</style>
